import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.302 6.70741L14.7127 6.11815C12.1092 3.51466 7.88815 3.51466 5.28465 6.11815C2.68116 8.72165 2.68116 12.9427 5.28465 15.5462C7.88815 18.1497 12.1092 18.1497 14.7127 15.5462C16.2268 14.0322 16.8603 11.9712 16.6134 9.9993M15.302 6.70741H11.7665M15.302 6.70741V3.17188",
  stroke: "currentColor",
  "stroke-width": "1.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }